import ContentfulStoreLocationApi from 'api/ContentfulStoreLocation';
import ACTIONS from 'state/constants';

export const fetchContentfulStorelocation = () => async dispatch => {
  dispatch({ type: ACTIONS.FETCH_STORE_LOCATION_REQUEST });

  const result = await ContentfulStoreLocationApi.fetchStoreLocationCollection();

  if (result?.length) {
    dispatch({ type: ACTIONS.FETCH_STORE_LOCATION_SUCCESS, payload: result });
  } else {
    dispatch({
      type: ACTIONS.FETCH_STORE_LOCATION_FAILURE,
      error: 'Fail to load content from Contentful, empty response',
    });
  }
};
